import {selectEventDetailsValid} from '~/CreateFabricInvitation/reducers/details/selectors';
import {UPDATE_EVENT_DETAILS} from '~/common/fabric/reducers/details/constants';

export const validateEventDetails = async (store) => {
  const valid = selectEventDetailsValid(store.getState(), false);
  if (!valid) {
    return valid;
  }
  if (!valid) {
    store.dispatch({
      type: UPDATE_EVENT_DETAILS,
      payload: {request: {failed: true}},
    });
    return false; // Prevent navigation
  }
  store.dispatch({
    type: UPDATE_EVENT_DETAILS,
    payload: {request: {failed: false}},
  });
  return true; // Allow navigation
};
